package org.company.app.data.model

import kotlinx.serialization.Serializable

@Serializable
data class SendOtpRequest(
    val email: String
)
